/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useLayoutEffect, useRef } from "react";

// react-router-dom components
import { Link } from "react-router-dom";
import "./dxpbooth.css"
// @mui material components
import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import PageLayout from "examples/LayoutContainers/PageLayout";
import {Amplify,Auth} from "aws-amplify";
import {AmplifyAuthenticator, AmplifySignIn} from '@aws-amplify/ui-react'

// Images
import curved9 from "assets/images/curved-images/curved-6.jpg";
import iam from 'assets/images/logos/images.png'
import { onAuthUIStateChange } from '@aws-amplify/ui-components'
import { I18n } from 'aws-amplify';
import Footer from "layouts/authentication/components/Footer";

import axios from "axios";
import { FileUploader } from "react-drag-drop-files";
import { IonIcon, IonLoading, IonModal, IonProgressBar } from "@ionic/react";
import {Done,Close} from "@mui/icons-material"
import {QrReader} from 'react-qr-reader'
import ProgressBar from "@ramonak/react-progress-bar";
import bg from 'assets/images/iaM.png';


function SignUpDXP() {

const [firstname, setfirstname] = useState("")
const [lastname, setlastname] = useState("")
const [email, setemail] = useState("")
const [IC,setIC] = useState("");
const [checkfile,setcheckfile] = useState(false);
const [checkfile1,setcheckfile1] = useState(false);

const [check1,setcheck1] = useState(0);
const [check1icon,setcheck1icon] = useState(<Close/>);

const [check2,setcheck2] = useState(0);
const [check2icon,setcheck2icon] = useState(<Close/>);

const [check3,setcheck3] = useState(0);
const [check3icon,setcheck3icon] = useState(<Close/>);
const [checkvalid,setcheckvalid] = useState("selfie");
const [valid,setvalid] = useState();
const [qr,setqr] = useState();
const [station,setstation] = useState("1")
const [prog,setprog] = useState(0)
const [hideqr,sethideqr] = useState(false)
const [hideocr,sethideocr] = useState(false)
const [cat,setcat] = useState("")
const [sek,setsek] = useState("")
const [phone,setphone] = useState("")



const  ref = useRef(null);





async function adduserfn(){
    setcheckfile1(true)
    await axios.get("https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/ExistCheckIam?id="+IC).then(async res7=>{
        if(res7.data == "true"){
            setcheckfile1(false)
            alert("Pengguna dengan no. kad pengenalan " + IC + " sudah wujud")
        }
        else {
            await axios.get("https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/GetLatestCertID").then(async value7=>{

                await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/AddUserCertificate",
                {
                  eventname: "iaM Digital Xperience 2022",
                  username: IC,
                  email:email,
                  fullname: firstname,
                  achievements: cat,
                  sekolah:sek,
                  phone: phone,
                  certid: parseInt(value7.data)+1
                }).then(value=>{
                  if(value.data == "success") {
                    setcheckfile1(false)
                    alert("Pendaftaran iaM Digital Xperience Berjaya. Sila semak emel bagi pengguna baru atau log masuk bagi pengguna yang telah berdaftar.")
                    window.location.href = "/"
                  }
                  else {
                    setcheckfile1(false)
                    alert("Pendaftaran Gagal.")
                  }
                })  
            })
        }
    })
 
  }



useEffect(()=>{
if(prog == 100) {
    sethideocr(true)
    sethideqr(true)
}
else if(prog == 0) {
    sethideocr(false)
    sethideqr(false)
}
},[prog])



async function uploadfile(file,booth) {
    if(IC != "") {
    setcheckfile(true)

    await  axios.get("https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/uploadfile?filename="+IC+booth+"&bucket=devbucket12").then(async (value)=>{
         //Create the FormData
         //Send the file to File-system
  console.log("Sending file to S3...");
  

  await axios.put(value.data, file, {
    }).then( async value => {
  console.log(value)

  await axios.get("https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/CheckImageText?textfind="+booth+"&filename="+IC+booth).then(value=>{
  console.log(value)          
  if(value.data=="Success") {
                if(booth == "STATION 1") {
                    setcheck1(1);
                    setprog(prog+33)
                    setcheck1icon(<Done/>)
                }
                else if(booth == "STATION 2") {
                    setcheck2(1)
                    setprog(prog+33)
                    setcheck2icon(<Done/>)

                }
                else if (booth == "STATION 3"){
                    setcheck3(1)
                    setprog(prog+34)
                    setcheck3icon(<Done/>)

                }
                setcheckfile(false)
            }
            else {
                if(booth == "STATION 1") {
                    setcheck1(0);
                    setcheck1icon(<Close/>)

                }
                else if(booth == "STATION 2") {
                    setcheck2(0)
                    setcheck2icon(<Close/>)

                }
                else if (booth == "STATION 3"){
                    setcheck3(0)
                    setcheck3icon(<Close/>)

                }
                setcheckfile(false)
                alert("Please Re-upload image. AI cannot detect "+ booth );
            }
  })



}).catch (error=> {
   console.log(error)
 })
 

  
}).catch(error =>{
  console.log(error)
})
    }
    else {
        alert("Enter Details First")
    }
   
      
    }





  return (
      
          <PageLayout background="#15172b">

  
      <div className="loading-cert" hidden={!checkfile}>
      <div>AI tengah analisa gambar anda. Tunggu sebentar</div>
      <div className="boxes">
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
  </div>
      </div>

      <div className="loading-cert" hidden={!checkfile1}>
      <div>Tunggu sebentar</div>
      <div className="boxes">
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
  </div>
      </div>
     
     
              <form class="form" hidden={checkfile || checkfile1} onSubmit={(e)=>{
                e.preventDefault();

                if(checkvalid == "selfie") {
                if(check1 == 1 && check2 == 1 && check3 == 1) {
                    adduserfn()
                }
                else {
                    alert("pastikan semua gambar telah disahkan")
                }
            }
            else if(checkvalid == "qr"){
                if(prog == 100) {
                    adduserfn()
                }
                else {
                    alert("Pastikan semua kod qr telah diimbas")
                }
            }
              }}>

                  <div class="title">Selamat Datang ke </div>
                 
                  <img src={bg} style={{width: "300px"}}/>
                  <div class="subtitle">Muat Turun Sijil Anda Sekarang!</div>
                  
                  <div class="input-container ic1">
           
                      <input id="firstname" class="input" type="text" placeholder=" " onChange={(e)=>{setfirstname(e.target.value)}} required />
                      <div class="cut"></div>
                  
                      <label for="firstname" class="placeholder">Nama Penuh</label>
                  </div>
                  <div class="input-container ic2">
                      <input id="email" class="input" type="email" placeholder=" " onChange={(e)=>{setemail(e.target.value)}} />
                      <div class="cut cut-short"></div>
                      <label for="email" class="placeholder">Emel</label>
                  </div>
                  <div class="input-container ic2">
                      <input id="email" class="input" type="text" placeholder=" " onChange={(e)=>{
                    
                        setIC(e.target.value)}} required />
                      <div class="cut cut-short"></div>
                      <label for="email" class="placeholder">No. Kad Pengenalan</label>
                  </div>
                  <div class="input-container ic2">
                      <input id="email" class="input" type="text" placeholder=" " onChange={(e)=>{
                    
                        setphone(e.target.value)}} required />
                      <div class="cut cut-short"></div>
                      <label for="email" class="placeholder">No. Telefon</label>
                  </div>
                  <div class="input-container ic2">                   
                      <select id="email" class="input" type="text" placeholder=" " required onChange={(e)=>{
                        setsek("")
                        setcat(e.target.value)}} >
                      <option value="" disabled selected class="placeholder">Pilih kategori</option>
                        <option value="participant">Pelajar</option>
                        <option value="advisor">Bukan Pelajar</option>
                      </select>

                  </div>
                  {cat == "participant" ? (
                      <div class="input-container ic2">
                      <input id="email" class="input" type="text" placeholder=" " onChange={(e)=>{
                    
                        setsek(e.target.value)}} required />
                      <div class="cut cut-short"></div>
                      <label for="email" class="placeholder">Sekolah / Intitusi Pengajian</label>
                  </div>
                  ):(
<></>
                  )}
                  <div class="input-container ic2">
                    <div class="newtext">Verifikasi melalui</div> 
                   
                      <select id="email" class="input" type="text" placeholder=" " required onChange={(e)=>{setcheckvalid(e.target.value)
                    setprog(0)
                    setqr()
                    setcheck3icon(<Close/>)
                    setcheck2icon(<Close/>)
                    setcheck1icon(<Close/>)
                    setcheck1(0)
                    setcheck2(0)
                    setcheck3(0)
                    setstation("1")
                    }} >
                        <option value="selfie">Selfie</option>
                        <option value="qr">Kod QR</option>
                      </select>

                  </div>
                  <br/>
                  <br/>
             
                <div class="newtext">Status Verifikasi</div>  
               <ProgressBar completed={prog} bgColor="rgb(125, 0, 127)" width="50%" isLabelVisible={false}/>
      
{checkvalid == "selfie" ? (

<div hidden={hideocr}><div class="input-container ic2">
<label class="newtext">Selfie STATION 1</label>{check1icon}
<FileUploader handleChange={(e) => { 
    console.log(IC)
    uploadfile(e, "STATION 1"); 
    
    } }
    label="Gambar Selfie Station 1"
    children={<div><button class="submit2">Gambar Selfie 1</button></div>}
    />
<div class="cut cut-short"></div>

</div><br />

<div class="input-container ic2">
    <label class="newtext">Selfie STATION 2</label>{check2icon}
    <FileUploader handleChange={(e) => { uploadfile(e, "STATION 2"); } }     
    label="Gambar Selfie Station 2"
    children={<div><button class="submit2">Gambar Selfie 2</button></div>}/>
    <div class="cut cut-short"></div>

</div><br /><div class="input-container ic2">
    <label class="newtext">Selfie STATION 3</label>{check3icon}
    <FileUploader handleChange={(e) => { uploadfile(e, "STATION 3"); } }     
    label="Gambar Selfie Station 3"
    children={<div><button class="submit2">Gambar Selfie 3</button></div>} />

    <div class="cut cut-short"></div>

</div></div> 

):(
    <><div class="input-container ic2" hidden={hideqr}>
    <label class="newtext">QR STATION {station}</label>
    <br />
    <button  type="button" class="submit1" onClick={() => { 
        
        setqr(

            <QrReader
            ref={ref}
            constraints={{facingMode: "environment" }}
            scanDelay={500}
            onResult={(result, error) => {
                console.log(result)
                if (!!result) {
                    if(result.text == "Station "+station){
               
                        alert("Pengimbasan Station "+ station + " Selesai")
                        setqr()
                        if(station == "1") {
                            setprog(33)
                            setstation("2")
                        }
                        else if(station == "2")
                        {
                            setprog(66)
                            setstation("3")
                            
                        }
                        else if(station == "3") {
                            setprog(100)
                        }
                       
                    }
                }
      
                if (!!error) {
                  console.info(error);
                }
              }}
       
       
            />
            
        )
     } }>Imbas QR {station}</button>
     

</div><br />
</>
)}
{(checkvalid == 'selfie' && check1 == 1 && check2 == 1 && check3 == 1) ? (

<>
    <div class="newtext">
 Verifikasi Selesai
</div>

</>

):(
    <>

    {(checkvalid == 'qr' && prog == 100) ? (
    <div class="newtext">
 Verifikasi Selesai
</div>
):(
<></>
)}
    </>
)}


{qr}

          
      
                  <br />
                  <button type="submit" class="submit" >submit</button>
              </form>


              <Footer />

          </PageLayout>



  );
}



export default SignUpDXP;
